import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './Link.scss';

const Link = props => (
  <a
    {...props}
    className={cx('link', props.className)}
  >
    {props.children}
  </a>
);

Link.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Link.defaultProps = {
  className: '',
};

export default Link;



// WEBPACK FOOTER //
// ./src/common/components/Link/Link.js